function Answerbox({ans, className}) {
	return (
		<input type="text" className={className} />
	);
}

export default Answerbox;